
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Head, Notes } from 'mdx-deck'
import { theme } from './theme'
export const themes = [theme];
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  themes
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Head mdxType="Head">
  <title>Presentation Title</title>
    </Head>
    <h1>{`Web Performance`}</h1>
    <hr></hr>
    <h2>{`Why is web performance important?`}</h2>
    <ul>
      <li parentName="ul">{`It makes user unconformable.`}</li>
      <li parentName="ul">{`It makes impact on sales.`}</li>
    </ul>
    <Notes mdxType="Notes">
that when a mobile site loads slowly, the user experiences the same stress as if they were watching a horror movie.
      <p>{`— In 2016, AliExpress made their site faster by a third and received 10.5% more orders
— Back in 2006, Google tried making the search slower by half-a-second and discovered that users were making 25% fewer requests
— In 2008, Aberdeen Group discovered that slowing a site down by one second decreases the user satisfaction by 16%`}</p>
      <p>{`and there’re lots of such data – from both old and recent studies (wpostats.com · pwastats.com).`}</p>
      <p>{`This is why web performance is important.`}</p>
    </Notes>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "https://github.com/jxnblk/mdx-deck"
      }}>{`https://github.com/jxnblk/mdx-deck`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;